interface Props {
  status: string;
  size?: "sm" | "md";
}

const colorMap: Record<string, string> = {
  connected: "bg-emerald-500/20 text-emerald-400",
  disconnected: "bg-zinc-500/20 text-zinc-400",
  connecting: "bg-amber-500/20 text-amber-400",
  qr_required: "bg-amber-500/20 text-amber-400",
  draft: "bg-zinc-500/20 text-zinc-400",
  running: "bg-blue-500/20 text-blue-400",
  paused: "bg-amber-500/20 text-amber-400",
  completed: "bg-emerald-500/20 text-emerald-400",
  sent: "bg-emerald-500/20 text-emerald-400",
  failed: "bg-red-500/20 text-red-400",
  skipped: "bg-amber-500/20 text-amber-400",
  queued: "bg-zinc-500/20 text-zinc-400",
  sending: "bg-blue-500/20 text-blue-400",
  pending: "bg-zinc-500/20 text-zinc-400",
  yes: "bg-red-500/20 text-red-400",
  no: "bg-emerald-500/20 text-emerald-400",
  F: "bg-pink-500/20 text-pink-400",
  M: "bg-blue-500/20 text-blue-400",
};

export default function StatusBadge({ status, size = "sm" }: Props) {
  const color = colorMap[status] || "bg-zinc-500/20 text-zinc-400";
  const s = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return <span className={s + " rounded-full font-medium " + color}>{status}</span>;
}
